// extracted by mini-css-extract-plugin
export default {"stepConfirmation":"Presenter-stepConfirmation_kYiOY"};